import { gql } from './client';
import { getDaikinStatus, setDaikinPower, setDaikinSetpoint, setDaikinFanSpeed } from '../graphql/queries';
import { DAIKIN_MOCK, mockGetStatus, mockSetPower, mockSetSetpoint, mockSetFanSpeed } from '../mocks/daikinMock';

// With REACT_APP_DAIKIN_MOCK="true" these hit an in-memory fake so the card works
// without the backend. Otherwise they call AppSync, which gates every Daikin call
// against the daily budget and serves a cached snapshot when it can. Control
// mutations send `expected` (the value the user was looking at): the backend
// re-reads live state and returns a `conflict` instead of clobbering an Onecta change.
// `refresh` (the Refresh button) lets the backend read live once the cache is a
// minute old instead of five; the backend enforces that floor.
export const fetchDaikinStatus = (refresh = false) =>
    DAIKIN_MOCK ? mockGetStatus() : gql(getDaikinStatus, { refresh }, 'getDaikinStatus');

export const setPower = (device_id, value, expected) =>
    DAIKIN_MOCK ? mockSetPower(device_id, value, expected)
        : gql(setDaikinPower, { device_id, value, expected }, 'setDaikinPower');

export const setSetpoint = (device_id, value, expected) =>
    DAIKIN_MOCK ? mockSetSetpoint(device_id, value, expected)
        : gql(setDaikinSetpoint, { device_id, value, expected }, 'setDaikinSetpoint');

// value = fixed fan step (1..fan_speed_max); expected = the step the user saw.
export const setFanSpeed = (device_id, value, expected) =>
    DAIKIN_MOCK ? mockSetFanSpeed(device_id, value, expected)
        : gql(setDaikinFanSpeed, { device_id, value, expected }, 'setDaikinFanSpeed');
